import * as React from "react";
import { connect } from "react-redux";
import { Theme, createStyles } from '@mui/material/styles';;
import { withStyles, WithStyles } from '@mui/styles';;
import idssStyle from "../../../Configuration/SharedStyling";
import {
    IGenericUserProps,
    genericMapStateToProps
} from "../../../DataClasses/GenericUser";
import { Redirect } from "react-router-dom";
import { AjaxError } from "rxjs/ajax";
import { firstValueFrom } from "rxjs";
import ReportsService from "../../Services/ReportsService";
import { IValidationReportData } from "../../../DataClasses/SubmissionData";
import BackNavigation from '../../Shared/BackNavigation';
import SharedMaterialReactTable, { ISharedTableColumn } from "../../Shared/MaterialReactTable";
import { Tooltip, IconButton, Grow, Dialog, Typography, Divider, Box, InputLabel, DialogContent, DialogTitle, DialogActions, Button, Grid2 as Grid } from '@mui/material';
import PageviewOutlinedIcon from '@mui/icons-material/PageviewOutlined';
import { ValidationRptError } from "../../../DataClasses/SharedData";

const styles = (theme: Theme) => createStyles({ ...idssStyle(theme) });

const LightTooltip = withStyles((theme: Theme) => ({
    tooltip: {
        backgroundColor: '#f2f2f2', // theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[16],
        fontSize: 11,
        fontStyle: 'oblique'
    },
}))(Tooltip);

interface IValidationReportState {
    isLoading: boolean;
    data: any[],
    redirect: boolean,
    validationDialogOpen: boolean,
    currentValidationItem: ValidationRptError
}

type IStylesProps = WithStyles<typeof styles>;

// VIEW
class ValidationReportView extends React.Component<
    IGenericUserProps & IStylesProps,
    IValidationReportState
> {
    constructor(props: any) {
        super(props);
        this.state = {
            isLoading: true,
            data: [],
            redirect: false,
            validationDialogOpen: false,
            currentValidationItem: null
        };
    }

    public componentDidMount() {
        this.RefreshModel();
    }

    // Template for columns with tooltip
    private validationColumnWithTooltip = (rowData: any, field: string) => {
        const value = rowData[field];
        const message = rowData.message || rowData[8];
        return (
            <LightTooltip title={message}>
                <div>{value}</div>
            </LightTooltip>
        );
    };

    // Template for Details column
    private detailsTemplate = (rowData: any) => {
        return (
            <div>
                <table>
                    <tbody>
                        <tr>
                            <td>
                                <Tooltip title="Show Details" aria-label="validationDetail">
                                    <IconButton size='small' aria-label="validationDetail" onClick={() => this.ShowValidationDialog(rowData)}>
                                        <PageviewOutlinedIcon fontSize="inherit"></PageviewOutlinedIcon>
                                    </IconButton >
                                </Tooltip>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    };

    public render() {
        if (this.state.redirect) {
            return <Redirect to="/error" />;
        }
        const { classes } = this.props;

        // Column definitions for SharedMaterialReactTable
        const getValidationReportColumns = (): ISharedTableColumn<any>[] => [
            {
                accessorKey: 'orgId' as any,
                header: 'Org Id',
                enableSorting: true,
                enableFiltering: true,
                Cell: ({ row }) => this.validationColumnWithTooltip(row.original, 'orgId'),
            },
            {
                accessorKey: 'subId' as any,
                header: 'Sub Id',
                enableSorting: true,
                enableFiltering: true,
                Cell: ({ row }) => this.validationColumnWithTooltip(row.original, 'subId'),
            },
            {
                accessorKey: 'orgName' as any,
                header: 'Org Name',
                enableSorting: true,
                enableFiltering: true,
                Cell: ({ row }) => this.validationColumnWithTooltip(row.original, 'orgName'),
            },
            {
                accessorKey: 'measureCode' as any,
                header: 'Measure',
                enableSorting: true,
                enableFiltering: true,
                Cell: ({ row }) => this.validationColumnWithTooltip(row.original, 'measureCode'),
            },
            {
                accessorKey: 'indicatorKey' as any,
                header: 'Indicator Key',
                enableSorting: true,
                enableFiltering: true,
                Cell: ({ row }) => this.validationColumnWithTooltip(row.original, 'indicatorKey'),
            },
            {
                accessorKey: 'shortIndicatorName' as any,
                header: 'Indicator',
                enableSorting: true,
                enableFiltering: true,
                Cell: ({ row }) => this.validationColumnWithTooltip(row.original, 'shortIndicatorName'),
            },
            {
                accessorKey: 'severity' as any,
                header: 'Severity',
                enableSorting: true,
                enableFiltering: true,
                Cell: ({ row }) => this.validationColumnWithTooltip(row.original, 'severity'),
            },
            {
                accessorKey: 'ruleName' as any,
                header: 'Rule Name',
                enableSorting: true,
                enableFiltering: true,
                Cell: ({ row }) => this.validationColumnWithTooltip(row.original, 'ruleName'),
            },
            {
                accessorKey: 'details' as any,
                header: 'Details',
                enableSorting: false,
                enableFiltering: false,
                enableColumnActions: false,
                size: 100,
                Cell: ({ row }) => this.detailsTemplate(row.original),
            },
        ];

        return (
            <div>
                <Dialog open={this.state.validationDialogOpen} onClose={() => this.CloseValidationDialog()} className={classes.dialogM} TransitionComponent={Grow}>
                    <DialogTitle >
                        <Typography className={classes.primaryBlueMedium}>
                            Validation Details
                        </Typography>
                        <Divider />
                    </DialogTitle>
                    <DialogContent>
                        {this.state.currentValidationItem ? <>{this.renderValaidationDetailGrid()}</> : null}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => this.CloseValidationDialog()}>Close</Button>
                    </DialogActions>
                </Dialog>
                <Grid container={true} className={classes.gridRowFlex} spacing={0}>
                    <Grid size={12}>
                        <Grid container={true} spacing={2}>
                            <Grid size={12}>
                                <BackNavigation text="Back to Reports" href="/reportspage" />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid size={12}>
                        <div className={classes.card}>
                            <SharedMaterialReactTable
                                data={this.state.data}
                                columns={getValidationReportColumns()}
                                title="Validation Report (HEDIS Only)"
                                isLoading={this.state.isLoading}
                                enablePagination={true}
                                enableSorting={true}
                                enableFiltering={true}
                                enableColumnActions={true}
                                enableRowActions={false}
                                initialState={{
                                    pagination: { pageIndex: 0, pageSize: 15 },
                                    sorting: [],
                                }}
                                muiPaginationProps={{
                                    rowsPerPageOptions: [15, 20, 25, 50, 75, 100, 500, 1000],
                                }}
                                emptyMessage="No validation data found."
                                muiTableProps={{
                                    sx: {
                                        tableLayout: 'fixed',
                                        '& .MuiTableRow-root:nth-of-type(odd)': {
                                            backgroundColor: 'rgba(0, 0, 0, 0.04)',
                                        },
                                        '& .MuiTableCell-root': {
                                            borderRight: '1px solid rgba(224, 224, 224, 1)',
                                        },
                                    },
                                }}
                            />
                        </div>
                    </Grid>
                </Grid>
            </div>
        );
    }

    private renderValaidationDetailGrid = () => {
        const { classes } = this.props;
        return <div>
            <Grid size={10} className={classes.flexGrow + " " + classes.fullWidth}>
                {this.state.currentValidationItem.orgId !== null ?
                    <Box flexGrow={1} className={classes.defaultMargin}>
                        <InputLabel shrink>Org Id</InputLabel>
                        <Typography variant="subtitle1" display="block" gutterBottom>
                            {this.state.currentValidationItem.orgId}
                        </Typography>
                    </Box> : null
                }
                {this.state.currentValidationItem.subId !== null ?
                    <Box flexGrow={1} className={classes.defaultMargin}>
                        <InputLabel shrink>Sub Id</InputLabel>
                        <Typography variant="subtitle1" display="block" gutterBottom>
                            {this.state.currentValidationItem.subId}
                        </Typography>
                    </Box> : null
                }
                {this.IsNonEmptyStr(this.state.currentValidationItem.orgName) ?
                    <Box flexGrow={1} className={classes.defaultMargin}>
                        <InputLabel shrink>Org Name</InputLabel>
                        <Typography variant="subtitle1" display="block" gutterBottom>
                            {this.state.currentValidationItem.orgName}
                        </Typography>
                    </Box> : null
                }
                {this.IsNonEmptyStr(this.state.currentValidationItem.measureCode) ?
                    <Box flexGrow={1} className={classes.defaultMargin}>
                        <InputLabel shrink>Measure Code</InputLabel>
                        <Typography variant="subtitle1" display="block" gutterBottom>
                            {this.state.currentValidationItem.measureCode}
                        </Typography>
                    </Box> : null
                }
                {this.IsNonEmptyStr(this.state.currentValidationItem.shortIndicatorName) ?
                    <Box flexGrow={1} className={classes.defaultMargin}>
                        <InputLabel shrink>Short Indicator Name</InputLabel>
                        <Typography variant="subtitle1" display="block" gutterBottom>
                            {this.state.currentValidationItem.shortIndicatorName}
                        </Typography>
                    </Box> : null
                }
                {this.IsNonEmptyStr(this.state.currentValidationItem.indicatorKey) ?
                    <Box flexGrow={1} className={classes.defaultMargin}>
                        <InputLabel shrink>Indicator Key</InputLabel>
                        <Typography variant="subtitle1" display="block" gutterBottom>
                            {this.state.currentValidationItem.indicatorKey}
                        </Typography>
                    </Box> : null
                }
                {this.IsNonEmptyStr(this.state.currentValidationItem.severity) ?
                    <Box flexGrow={1} className={classes.defaultMargin}>
                        <InputLabel shrink>Severity</InputLabel>
                        <Typography variant="subtitle1" display="block" gutterBottom>
                            {this.state.currentValidationItem.severity}
                        </Typography>
                    </Box> : null
                }
                {this.IsNonEmptyStr(this.state.currentValidationItem.ruleName) ?
                    <Box flexGrow={1} className={classes.defaultMargin}>
                        <InputLabel shrink>Rule Name</InputLabel>
                        <Typography variant="subtitle1" display="block" gutterBottom>
                            {this.state.currentValidationItem.ruleName}
                        </Typography>
                    </Box> : null
                }
                {this.IsNonEmptyStr(this.state.currentValidationItem.message) ?
                    <Box flexGrow={1} className={classes.defaultMargin}>
                        <InputLabel shrink>Message</InputLabel>
                        <Typography variant="subtitle2" display="block" gutterBottom>
                            {this.state.currentValidationItem.message}
                        </Typography>
                    </Box> : null
                }
            </Grid></div>
    }
    private IsNonEmptyStr = (s: string) => {
        return (s && s.length > 0)
    }

    private ShowValidationDialog = (rowData: any) => {
        this.setState({
            currentValidationItem: {
                orgId: rowData.orgId,
                subId: rowData.subId,
                orgName: rowData.orgName,
                measureCode: rowData.measureCode,
                indicatorKey: rowData.indicatorKey,
                shortIndicatorName: rowData.shortIndicatorName,
                severity: rowData.severity,
                ruleName: rowData.ruleName,
                message: rowData.message,
            },
            validationDialogOpen: true
        });
    }

    private CloseValidationDialog() {
        this.setState({
            validationDialogOpen: false,
        });
    }

    private async RefreshModel() {
        this.setState({ isLoading: true });
        const retval: IValidationReportData[] | AjaxError = await firstValueFrom(
            ReportsService.GetValidationReportData$(this.props.user)
        );
        if (retval instanceof AjaxError || !retval) {
            this.setRedirectState();
        } else {
            this.setState({
                data: retval.map(x => ({
                    orgId: x.orgId,
                    subId: x.subId,
                    orgName: x.orgName,
                    measureCode: x.measureCode,
                    indicatorKey: x.indicatorKey,
                    shortIndicatorName: x.shortIndicatorName,
                    severity: x.severity,
                    ruleName: x.ruleName,
                    message: x.message
                }))
            });
        }
        this.setState({ isLoading: false });
    }

    private setRedirectState() {
        this.setState({ redirect: true });
    }
    private redirectToErrorPage() {
        return <Redirect to='/errorpage' />;
    }
}

// REDUX CONTAINER
const ValidationReportPageWithState = connect<IGenericUserProps>(
    genericMapStateToProps
)(ValidationReportView);

// STYLES CONTAINER
const ValidationReport = withStyles(styles)(
    ValidationReportPageWithState
);

export default ValidationReport;
